import { throttle } from 'lodash';

export function wppage() {
  const footers = document.querySelectorAll('footer');
  for (let index = 0; index < footers.length; index++) {
    const footer = footers[index];
    if ( footer.classList.contains('footer') == true ) {
      footer.remove();
    }
  }

  // const header_bar = document.querySelector('.header-bar');
  // header_bar.remove();

  window.addEventListener(
    'scroll',
    _.throttle(
      e => {
        // ここに処理

        var y = window.pageYOffset ;
        const wp_header = document.querySelector('.l-header--wp');
        if ( y > 0 ) {
          wp_header.classList.add('is-animated');
        } else {
          wp_header.classList.remove('is-animated');
        }
        return false;
      },
      50,
      { trailing: true, leading: true }
    )
  );

  var path = location.pathname ;
  const signage = document.querySelector('.signage');
  const mv = document.querySelector('.c-kvSub');
  if (window.matchMedia('(max-width: 767px)').matches) {
    //スマホ処理
    if ( path == '/mysite-entry/' ) {
      // signage.classList.add('mysite-form');
    } else if ( path == '/seminar-form/' ) {
      signage.classList.add('seminar-form');
    }
  }

  if ( path == '/mysite-entry-form/' ) {
    signage.remove();
  } else if ( path == '/seminar-form/' ) {
    mv.remove();
  }
}